import React from 'react';
import TemplateModern from './TemplateModern';
import TemplateElegant from './TemplateElegant';
import TemplateTrust from './TemplateTrust';
import { NICHES_CONFIG } from './niches';

const TEMPLATES = {
  modern: TemplateModern,
  elegant: TemplateElegant,
  trust: TemplateTrust,
  default: TemplateModern // Fallback por si acaso
};

const TemplateRenderer = ({ workshopData }) => {
  // Obtenemos la configuración del nicho, con un fallback seguro a 'otros' si no existe
  const nicheConfig = NICHES_CONFIG[workshopData?.niche] || NICHES_CONFIG['otros'];
  
  // Obtenemos la clave del template o usamos un fallback
  const templateKey = nicheConfig?.template || 'default';
  const TemplateComponent = TEMPLATES[templateKey] || TEMPLATES.default;

  // Renderizamos el template inyectando los datos del taller y la config del nicho
  return <TemplateComponent data={workshopData} config={nicheConfig} />;
};

export default TemplateRenderer;